import Main from "./Main";

import { ReactComponent as LogoIcon } from 'icons/logo.svg';
/*import { ReactComponent as TreeIcon } from 'icons/tree.svg';*/
/*import { ReactComponent as FlowersIcon } from 'icons/flowers.svg';*/

export default class Abstract extends Main {
    insertLogo() {
        return <LogoIcon className="logo" />;
    }

    insertTree(i, width) {
        return (<div className="pos rel" style={{ width, /*transform: `scaleX(${i})`*/ }} >
            {/* data-tooltip={"Весна"}*/}
            <div className="pos abs" style={{ top: "-15px", left: "30px", fontStyle: "italic", color: "#496481", fontWeight: "600" }} >
                {/*<TreeIcon className="logo" />*/}
                {/*<FlowersIcon />*/}
                <div className="">{"Назначил повторный визит в карте - позаботился о пациенте!"}</div>
            </div>
        </div>);
    }

    currPage() {
        return window.location.pathname.slice(1);
    }

    changeLanguage(lang) {
        localStorage.setItem('language', lang);

        this._helper.currentLanguage = lang;
        this._helper.moment.locale(lang);
        this._helper.i18next.changeLanguage(lang).then(() => {
            globalThis.appPageView.forceUpdate();
        });

    }
}
